import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ChevronLeftBig = ({ ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.1544 4.04218C17.6834 4.67974 17.5954 5.6254 16.9578 6.15437L9.91231 12L16.9578 17.8456C17.5954 18.3746 17.6834 19.3202 17.1544 19.9578C16.6254 20.5953 15.6798 20.6833 15.0422 20.1544L7.35109 13.7731C6.8285 13.3395 6.5 12.7039 6.5 12C6.5 11.2961 6.8285 10.6605 7.35109 10.2269L8.30889 11.3813L7.35109 10.2269L15.0422 3.84558C15.6798 3.31661 16.6254 3.40463 17.1544 4.04218Z'
      fill='currentColor'
    />
  </IconBase>
);
